import { BaseConditionData } from './base-condition-data';
import { WorkflowConditionTypes } from './Enums/workflow-condition-types';

/**
 * Représente les données d'une condition 'Etape activée'.
 */
export class ActivatedStepsConditionData extends BaseConditionData {
    /**
     * Ids des étapes devant être complétées.
     */
    public steps: number[] = [];

    /**
     * Constructeur.
     */
    constructor() {
        super(WorkflowConditionTypes.StepActivated);
    }

    /**
     * Retourne une copie d'une instance de ActivatedStepsConditionData
     * @param other : Instance source.
     * @returns : Copie de l'instance.
     */
    public static clone(other: ActivatedStepsConditionData) {
        if (!!other) {
            const instance = new ActivatedStepsConditionData();
            instance.steps = other.steps;
            instance.name = other.name;
            instance.type = other.type;
            instance.id = other.id;
            instance.isMainCondition = other.isMainCondition;

            return instance;
        } else {
            return null;
        }
    }
}
